<template>
    <div>
        <!-- 路网管理平台 -->
        <div
            v-if="dialogActiveApp.id == 'f95540fd-2721-4d06-af9e-04908f496bd7'"
        >
            <div class="experienceItem_bottomborder aeroiotflex_row">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/highway1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <div class="experienceItem_title">高速设施物联网</div>
                    <div class="experienceItem_tip1">
                        提供路况环境、温度、湿度数据，道路结冰等气候预警；车流量情况的实时监控、可调取路桥隧监控、
                        隧道运营情况监控、桥梁情况
                    </div>
                    <div class="experienceItem_decorate1"></div>
                    <div class="aeroiotflex_row">
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>路面结冰监测</div>
                        </div>
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>事件运营监测系统</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>精准车流量采集系统</div>
                        </div>
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>移动端运营监控系统</div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="experienceItem_bottomborder aeroiotflex_row"
                style="margin-top: 11px"
            >
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 24px; margin-right: 112px"
                >
                    <div class="experienceItem_title">机电监测+路桥隧监测</div>
                    <div class="experienceItem_tip1">
                        路面养护及评价模块&nbsp;&nbsp;&nbsp;机电设备养护模块&nbsp;&nbsp;&nbsp;桥梁定期检测系统&nbsp;&nbsp;&nbsp;道路巡查车工作轨迹及情况
                    </div>
                    <div class="experienceItem_decorate1"></div>
                    <div class="aeroiotflex_row">
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>重点桥梁运营监测系统</div>
                        </div>
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>路侧边坡监测系统</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>隧道机电监测系统</div>
                        </div>
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>桥梁定期检测系统</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>隧道定期检测系统</div>
                        </div>
                        <div class="experienceItem_tip2 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>路桥隧养护管理系统</div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/highway2.png"
                        alt=""
                    />
                </div>
            </div>
            <div
                class="experienceItem_bottomborder aeroiotflex_row"
                style="margin-top: 36px"
            >
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/highway3.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 29px"
                    >
                        路面AI巡检
                    </div>
                    <div class="aeroiotflex_row" style="width: 100%">
                        <div class="experienceItem_tip3 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>标志标牌识别</div>
                        </div>
                        <div class="experienceItem_tip3 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>隧道视频内容识别</div>
                        </div>
                        <div class="experienceItem_tip3 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>路面病害识别</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="aeroiotflex_row" style="margin-top: 39px">
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 19px; margin-right: 78px"
                >
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 21px"
                    >
                        固定点视频AI分析
                    </div>
                    <div class="aeroiotflex_row" style="flex-wrap: wrap">
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>实现变道检测</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>时间占有率</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>交通流量统计</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>车辆轨迹记录</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>车速计算</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>排队拥堵</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>人行检测</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>逆向行驶检测</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>车道平均速度</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>车头时距</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>违法停车检测</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>禁区检测</div>
                        </div>
                        <div class="experienceItem_tip4 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>空间占有率</div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/highway4.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
        <!-- 隧道监测 工程监测云 -->
        <div
            v-if="dialogActiveApp.id == '498836c5-1bb8-41a1-bd0e-563628f3db2c'"
        >
            <div class="experienceItem_bottomborder aeroiotflex_row">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/tunnelop1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <!-- <div
                        class="experienceItem_title"
                        style="margin-bottom: 20px"
                    >
                        标准化超前地质预报
                    </div> -->
                    <div
                        class="aeroiotflex_row"
                        style="align-items: flex-start; margin-bottom: 20px"
                    >
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 54px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon1.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    系统概况首页
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    隧道运营总体概览，预警、模型展示、<br />GIS一张图
                                </div>
                            </div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon2.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    数据分析
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    监测数据汇总、图表数据趋势分析
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="aeroiotflex_row"
                        style="align-items: flex-start"
                    >
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon3.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    预警推送
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    支持红、橙、黄、蓝四色预警分级推送、<br />邮件、短信、微信推送
                                </div>
                            </div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon4.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    自动生成监测报告
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    系统自动根据周、月、季生成监测<br />报告
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="experienceItem_bottomborder aeroiotflex_row"
                style="margin-top: 11px"
            >
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 24px; margin-right: 140px"
                >
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 20px; margin-top: 2px"
                    >
                        隧道BIM与三维建模
                    </div>
                    <div class="aeroiotflex_row" style="margin-bottom: 15px">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon5.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    隧道三维建模
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    隧道运营期间三维地质模型，整合建设期勘查、超前预报、<br />
                                    1:5000地形图数据建立隧道三维地质模型，包括地下水、<br />
                                    松散层分布，定期隧道探测对模型数据实时更新。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon6.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    隧道BIM
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    隧道锚杆BIM、隧道监测断面BIM
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/tunnelop2.png"
                        alt=""
                    />
                </div>
            </div>
            <div
                class="aeroiotflex_row"
                style="margin-top: 36px; margin-bottom: 98px"
            >
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/tunnelop3.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 29px"
                    >
                        自动监控量测技术
                    </div>
                    <div class="aeroiotflex_row" style="margin-bottom: 15px">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon7.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    隧道断面监测仪
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    通过隧道断面监测仪，可以实现监控量测数据自动采集、<br />
                                    无线传输、智能分析、及时预警
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon8.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    变形趋势分析
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    支持时间-位移、时间-速率、时间-加速度分析<br />
                                    支持多项式回归分析算法<br />
                                    支持趋势的预测，自动计算累计位移、拟合曲线
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 河堤监测 工程监测云 -->
        <div
            v-if="dialogActiveApp.id == '2377d331-524c-441a-be4d-cd20a7b04001'"
        >
            <div class="aeroiotflex_row experienceItem_bottomborder">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/reach1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 37px">
                    <div
                        class="aeroiotflex_row"
                        style="align-items: flex-start; margin-bottom: 20px"
                    >
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 94px"
                        >
                            <img
                                src="@/assets/experienceContentImg/reachIcon1.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    报警信息
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    红、黄、橙、蓝预警信息<br />
                                    预警原因综合分析<br />
                                    分级别预警推送
                                </div>
                            </div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start"
                        >
                            <img
                                src="@/assets/experienceContentImg/reachIcon2.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    自动生成监测报告
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    系统自动根据周、月、季生成监测<br />
                                    报告
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="aeroiotflex_row"
                style="margin-top: 25px; margin-bottom: 73px"
            >
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 17px; margin-right: 184px"
                >
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip6 aeroiotflex_row"
                            style="margin-right: 120px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>水位变化分析</div>
                        </div>
                        <div class="experienceItem_tip6 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>视频与传感器融合</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip6 aeroiotflex_row"
                            style="margin-right: 106px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>降雨量变化分析</div>
                        </div>
                        <div class="experienceItem_tip6 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>环境监测统计分析</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div class="experienceItem_tip6 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>GNSS位移分析</div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/reach2.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
        <!-- 积水监测 工程监测云 -->
        <div
            v-if="dialogActiveApp.id == '98774a44-0328-4ce7-b806-b4ed21448542'"
        >
            <div class="aeroiotflex_row experienceItem_bottomborder">
                <div class="aeroiotflex_center">
                    <img src="@/assets/experienceContentImg/rain1.png" alt="" />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 37px">
                    <div
                        class="aeroiotflex_row"
                        style="align-items: flex-start; margin-bottom: 20px"
                    >
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 94px"
                        >
                            <img
                                src="@/assets/experienceContentImg/reachIcon1.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    报警信息
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    红、黄、橙、蓝预警信息<br />
                                    预警原因综合分析<br />
                                    分级别预警推送
                                </div>
                            </div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start"
                        >
                            <img
                                src="@/assets/experienceContentImg/reachIcon2.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    自动生成监测报告
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    系统自动根据周、月、季生成监测<br />
                                    报告
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="aeroiotflex_row"
                style="margin-top: 25px; margin-bottom: 43px"
            >
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 17px; margin-right: 184px"
                >
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip6 aeroiotflex_row"
                            style="margin-right: 120px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>水位变化分析</div>
                        </div>
                        <div class="experienceItem_tip6 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>视频与传感器融合</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip6 aeroiotflex_row"
                            style="margin-right: 106px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>降雨量变化分析</div>
                        </div>
                        <div class="experienceItem_tip6 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>环境监测统计分析</div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img src="@/assets/experienceContentImg/rain2.png" alt="" />
                </div>
            </div>
        </div>
        <!-- 边坡监测 工程监测云 -->
        <div
            v-if="dialogActiveApp.id == 'b330cb0a-7448-402e-8982-f9b0b3952980'"
        >
            <div class="aeroiotflex_row experienceItem_bottomborder">

                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/slope1.png"
                        alt=""
                    />
                </div>
                                <div
                    class="aeroiotflex_col"
                    style="margin-left: 32px;"
                >
                    <div
                        class="aeroiotflex_row"
                        style="align-items: flex-start; margin-bottom: 20px"
                    >
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 111px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon1.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    概况信息
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    边坡预警总体状态<br />
                                    地质物探信息集成<br />
                                    视频+监测传感器融合<br />
                                    GIS+三维可视化集成<br />
                                    无人机倾斜数据集成
                                </div>
                            </div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon2.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    数据分析
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    改进型切线角分析<br />
                                    表面、深部位移趋势分析<br />
                                    边坡稳定性评价分析<br />
                                    散点图分析<br />
                                    监测数据关联性分析
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="aeroiotflex_row"
                        style="align-items: flex-start"
                    >
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 94px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon3.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div
                                class="aeroiotflex_col"
                                style="margin-bottom: 20px"
                            >
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    报警信息
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    红、黄、橙、蓝预警信息<br />
                                    预警原因综合分析<br />
                                    分级别预警推送
                                </div>
                            </div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelopIcon4.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    自动生成监测报告
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    系统自动根据周、月、季生成监测<br />报告
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="aeroiotflex_row"
                style="margin-top: 21px; margin-bottom: 33px"
            >
                            <div class="aeroiotflex_col" style="margin-left: 15px;margin-right:20px">
                    <div class="aeroiotflex_row" style="width: 100%">
                        <div
                            class="experienceItem_tip7 aeroiotflex_row"
                            style="margin-right: 40px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>实时动态表面位移分析</div>
                        </div>
                        <div
                            class="experienceItem_tip7 aeroiotflex_row"
                            style="margin-right: 40px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>累计位移、加速度、趋势变化分析</div>
                        </div>
                        <div class="experienceItem_tip7 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>视频与传感器融合</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row" style="width: 100%">
                        <div
                            class="experienceItem_tip7 aeroiotflex_row"
                            style="margin-right: 68px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>深部位移变化分析</div>
                        </div>
                        <div
                            class="experienceItem_tip7 aeroiotflex_row"
                            style="margin-right: 96px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>北斗位移散点图变化分析</div>
                        </div>
                        <div class="experienceItem_tip7 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>环境监测统计分析</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row" style="width: 100%">
                        <div class="experienceItem_tip7 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>降雨量变化分析</div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/slope2.png"
                        alt=""
                    />
                </div>

            </div>
        </div>
        <!-- 水库监测 工程监测云 -->
        <div
            v-if="dialogActiveApp.id == '72831608-0898-4bc2-bfa0-ee18beea15ca'"
        >
            <div class="experienceItem_bottomborder aeroiotflex_row">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/shuiku1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 32px"
                    >
                        监测分析组件
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 50px 13px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>GNSS位移回归分析</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 50px 13px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>水库报告自动生成</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 13px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>浸润线断面分析</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 92px 13px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>GNSS散点图</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 92px 13px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>降雨量日历</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 13px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>风速时程分析</div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="experienceItem_bottomborder aeroiotflex_row"
                style="margin-top: 11px"
            >
                <div class="aeroiotflex_col" style="margin-left: 60px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 28px"
                    >
                        灵活的组件配置
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 108px 21px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>水库自定义模型</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 21px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>图像监测数据融合</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 122px 21px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>功能面板配置</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 146px 21px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>自定义布点、功能菜单配置</div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/shuiku2.png"
                        alt=""
                    />
                </div>
            </div>
            <div
                class="aeroiotflex_row"
                style="margin-top: 36px; margin-bottom: 46px"
            >
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/shuiku3.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 18px"
                    >
                        三维模型、地图、工程CAD
                    </div>
                    <div class="aeroiotflex_row" style="width: 100%">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 172px 7px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>水库三维模型</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 7px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>无人机倾斜摄影</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row" style="width: 100%">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 205px 7px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>GIS地图</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 7px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>工程CAD 布点图</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 桥梁监测 工程监测云 -->
        <div
            v-if="dialogActiveApp.id == 'bc84fa8d-5e1c-4542-a6bc-c931ae503007'"
        >
            <div class="experienceItem_bottomborder aeroiotflex_row">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/bridge1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 110px;margin-bottom:17px;">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 12px"
                    >
                        桥梁工程分析功能模块
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 142px 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">挠度趋势分析</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">车速统计</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 142px 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">车辆荷载分析</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">位移趋势分析</div>
                        </div>
                    </div>
                                        <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 151px 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">桥梁CT集成</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">桥梁BIM</div>
                        </div>
                    </div>
                                        <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 86px 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">定检、经常性巡检集成</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">视频集成</div>
                        </div>
                    </div>
                                        <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 114px 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">手机、微信端支持</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">周报、月报自动生成</div>
                        </div>
                    </div>
                                        <div
                        class="experienceItem_title"
                        style="margin-bottom: 11px;margin-top: 13px"
                    >
                        可视化编辑
                    </div>
                                                            <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 128px 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">桥梁自定义结构</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">挠度变化配置</div>
                        </div>
                    </div>
                                                            <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 142px 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">功能面板配置</div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0 10px 0"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div style="color:#666666">自定义布点、功能菜单配置</div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="aeroiotflex_row"
                style="margin-top: 37px"
            >
                <div class="aeroiotflex_col" style="margin-right:54px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 10px"
                    >
                        监测数据可视化
                    </div>
                    <div class="aeroiotflex_row" style="margin-bottom:30px">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items:flex-start;"
                        >
                            <div class="experienceItem_decorate2" style="margin-top:7px"></div>
                            <div style="font-size:12px;color:#666666">多样化数据展示，基于物联网、云计算等技术，实现数据的可视化与云储存，实时掌握监测对<br/>象运营状态</div>
                        </div>
                    </div>
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 10px"
                    >
                        桥梁实时车辆荷载监测
                    </div>
                    <div class="aeroiotflex_row" style="margin-bottom:30px">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items:flex-start;"
                        >
                            <div class="experienceItem_decorate2" style="margin-top:7px"></div>
                            <div style="font-size:12px;color:#666666">由重车检测配套传感器设备结合互联网技术建立的全自动检测点，可在不影响交通的基础上，<br/>监测到车辆的全车图片、车前脸特写图片、车牌照号、单轴重、轴数、轴组重、总车重、轴间<br/>距、总轴距、车长、车速、车流量、车间距、行驶方向、车型等，从而可判断出超载车</div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/bridge2.png"
                        alt=""
                    />
                </div>
            </div>

        </div>
        <!-- 工程监测云 -->
        <div
            v-if="dialogActiveApp.id == '85a84a1d-b092-4b7b-b906-d6242d2ba74a'"
        >
            <div class="aeroiotflex_row" style="margin:36px 0 106px 0">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/monitor1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 27px">
                    <div class="experienceItem_tip1" style="color:#303030;line-height: 20px;">
                        工程监测预警SaaS平台，提供多种预警分析组件，支持自定义可视化组件，为桥梁、<br/>边坡、隧道、道路、水库、基坑、房屋提供在线监测与预警服务。
                    </div>

                </div>
            </div>

        </div>
        <!-- 大屏系统 -->
        <div
            v-if="dialogActiveApp.id == 'cc127130-f5d2-451d-b1b2-f41622d44ce4'"
        >
            <div class="aeroiotflex_row" style="margin:36px 0 106px 0">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/dashboard1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 27px">
                    <div class="experienceItem_tip1" style="color:#303030;line-height: 20px;">
                       内置众多工程检测类模板；拖拽式操作、丰富的可视化效果、轻松搭建桥梁、隧道、<br/>边坡等专业水准的实时数据监控可视化大屏；数据可视化支持智能手机、平板电脑、<br/>智能电视屏等多终端可视化展现；可实现三维模型、卫星地图、高精度底图等多形式<br/>底图展示。
                    </div>

                </div>
            </div>

        </div>
        <!-- 隧道三维地质与实时监控系统 -->
        <div
            v-if="dialogActiveApp.id == 'dd3c00ad-1702-4fc6-93a6-9f06ad8f9d1c'"
        >
            <div
                class="aeroiotflex_row"
                style="align-items: flex-start; margin-bottom: 106px"
            >
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/tunnelsanwei.png"
                        alt=""
                    />
                </div>
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 37px; margin-top: 19px"
                >
                    <div class="tunnelsanweitip">
                        将施工过程中超前地质预报、监控量测、质量检测、地质勘察通过三维模型可视化。<br />
                        特点是地质三维，实现了落水洞、充水岩溶通道、断层、富水破碎带等地质模型与空<br />间物探数据、隧道位置的三维可视化，最终预测出不良地质的空间分布，构造与地下<br />水及其之间的水力联通关系，相对位置关系，为隧道施工、处治提供了依据。为后期<br />施工建设提供可靠依据，有效减少开挖时产生的坍塌冒顶、突水、突泥等事故。
                    </div>

                    <div class="aeroiotflex_row" style="margin-top: 33px">
                        <div
                            class="experienceItem_tip6 aeroiotflex_row"
                            style="margin-right: 92px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>施工进度、掌子面位置可视化</div>
                        </div>
                        <div class="experienceItem_tip6 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>监控量测预警可视化</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip6 aeroiotflex_row"
                            style="margin-right: 92px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>超前预报检测数据三维可视化</div>
                        </div>
                        <div class="experienceItem_tip6 aeroiotflex_row">
                            <div class="experienceItem_decorate2"></div>
                            <div>地质情况可视化</div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip6 aeroiotflex_row"
                            style="margin-right: 106px"
                        >
                            <div class="experienceItem_decorate2"></div>
                            <div>初支二衬质量检测情况可视化</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 经开区公共工程安全监测平台 -->
        <div
            v-if="dialogActiveApp.id == '2f4e2605-1443-4e14-b58a-ee3e480b5603'"
        >
            <div class="experienceItem_bottomborder aeroiotflex_row">
                <div
                    class="aeroiotflex_center"
                    style="margin-left: 50px; margin-bottom: 32px"
                >
                    <img src="@/assets/experienceContentImg/city1.png" alt="" />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 14px"
                    >
                        城市公共工程感知网络
                    </div>
                    <div class="experienceItem_tip1">
                        城市感知网络，就是在不同的监测物上安装传感器，对于人来说，需要“望、闻、问、<br />切”，对于城市公共工程设施，需要感知内部结构、周边环境感知、现场图像。
                    </div>
                </div>
            </div>
            <div
                class="experienceItem_bottomborder aeroiotflex_row"
                style="margin-top: 21px"
            >
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 36px; margin-right: 112px"
                >
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 14px"
                    >
                        7x24小时城市监测预警
                    </div>
                    <div class="experienceItem_tip1">
                        通过监测传感器和专业分析软件，实时对城市工程进行7X24小时监测预警，并打通网<br />页、小程序、短信息实现多端报警。
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img src="@/assets/experienceContentImg/city2.png" alt="" />
                </div>
            </div>
            <div class="experienceItem_bottomborder aeroiotflex_row">
                <div
                    class="aeroiotflex_center"
                    style="
                        margin-left: 50px;
                        margin-top: 21px;
                        margin-bottom: 27px;
                    "
                >
                    <img src="@/assets/experienceContentImg/city3.png" alt="" />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 14px"
                    >
                        城市公共工程运维平台
                    </div>
                    <div class="experienceItem_tip1">
                        通过一屏多系统展示，让城市运营方直观查看工程预警和设备故障。
                    </div>
                </div>
            </div>
            <div
                class="aeroiotflex_row"
                style="margin-top: 21px; margin-bottom: 45px"
            >
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 48px; margin-right: 172px"
                >
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 14px"
                    >
                        三维可视化城市引擎
                    </div>
                    <div class="experienceItem_tip1">
                        GIS数据+无人机数据采集技术，实现虚拟3D场景与现实1:1还原，真实还原城市地势、建<br />筑、检测物、天气、光照及未建成建筑或工程。
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img src="@/assets/experienceContentImg/city4.png" alt="" />
                </div>
            </div>
        </div>
        <!-- 道路检测系统 -->
        <div
            v-if="dialogActiveApp.id == '2ede3100-33ce-4122-be15-ec3d087a2703'"
        >
            <div class="aeroiotflex_row" style="margin:72px 0 55px -35px">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/road1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 18px;">
                    <div
                        class="experienceItem_title aeroiotflex_row"
                        style="margin-bottom: 8px"
                    >
                        <div class="experienceItem_decorate2"></div>
                        <div style="margin-right:190px">高速高精度定位技术</div>
                        <div class="experienceItem_decorate2"></div>
                        <div>病害自动识别技术</div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 0px 47px 0;position:relative;width:630px;"
                        >
                            <div class="experienceItem_decorate2" style="visibility: hidden;"></div>
                            <div style="color:#999999;font-size:12px;line-height:22px;">加装北斗车载高精度定位系统+开发定位匹配程序，<br/>实现80Km车速下，2m以内的检测数据定位精度</div>
                            <div style="color:#999999;font-size:12px;line-height:22px;position:absolute;left:354px;top:0;">通过机器视觉+深度学习，使路面、桥梁病害识别达<br/>到95%准确度</div>
                        </div>
                    </div>
                                        <div
                        class="experienceItem_title aeroiotflex_row"
                        style="margin-bottom: 8px"
                    >
                        <div class="experienceItem_decorate2"></div>
                        <div style="margin-right:222px">检测数据平台化</div>
                        <div class="experienceItem_decorate2"></div>
                        <div>养护分析及决策技术</div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="margin: 0 142px 10px 0;position:relative;width:630px;"
                        >
                            <div class="experienceItem_decorate2" style="visibility: hidden;"></div>
                            <div style="color:#999999;font-size:12px;line-height:22px;">根据路面检测数据及病害自动生成评定结果，一张图<br/>方式重现道路检测轨迹，通过红、黄、蓝、绿四种颜<br/>色表示不同技术状况等级及分布</div>
                            <div style="color:#999999;font-size:12px;line-height:22px;position:absolute;left:354px;top:0;">针对地区提出路面养护决策树；明确各种养护措施的<br/>适用条件和范围；针对实际路况选择最佳的养护方案</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- 隧道施工安全系统 -->
        <div
        style="margin-left:-17px;margin-right:-17px"
            v-if="dialogActiveApp.id == '55a8e565-ec2b-4cdc-9004-1f125a11be2d'"
        >
            <div class="experienceItem_bottomborder aeroiotflex_row">
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/tunnel1.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 15px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 20px"
                    >
                        标准化超前地质预报
                    </div>
                    <div
                        class="aeroiotflex_row"
                        style="align-items: flex-start; margin-bottom: 20px"
                    >
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 36px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelIcon1.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    标准化的输入输出
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    标准化输入。支持地质调查法、大功率电测<br/>
                                    深法、大地电磁测深法、地震波法、地质雷<br/>
                                    达法、超前钻探法、超前导坑预报法等各种<br/>
                                    方法数据的导入
                                </div>
                            </div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelIcon2.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    超前预报专利技术
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    大功率电测深三维成像技术方法<br/>
                                    地震波法隧道三维超前预报技术<br/>
                                    地质雷达三维超前预报技术

                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="aeroiotflex_row"
                        style="align-items: flex-start;margin-bottom:37px;"
                    >
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelIcon3.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    超前预报功能
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    不良地质段分级与自动预警；不同地质超前<br/>
                                    预报方法对比；掌子面照片和素描；超前预<br/>
                                    报报告档案管理、自动生成；围岩级别跟踪
                                </div>
                            </div>
                        </div>
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelIcon4.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    超前预报预警手机推送
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    根据超前地质预报结果，可直接将微信<br/>
                                    结果快速分享推送给指挥部和施工方，预<br/>
                                    警分为红色预警、橙色预警、黄色预警、<br/>
                                    蓝色预警、无预警
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="font-size: 16px;font-weight: 500;color: #303030;margin:26px 0 25px 5px">
                地质三维与地质雷达集成
            </div>
            <div
                class="experienceItem_bottomborder aeroiotflex_row"
            >
                <div
                    class="aeroiotflex_col"
                    style="margin-left: 5px;margin-bottom:30px"
                >
                    <div class="aeroiotflex_row" style="margin-bottom: 15px">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start;"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelIcon5.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    地质模型成果可视化
                                </div>
                                <div class="experienceItem_tip5-tip">
                    系统通过地表勘查数据建立隧道三维地质模型，包括地下水、松散层分布，可让管理者直观了解<br/>
                    隧道周边地质状况。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelIcon6.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 13px; margin-top: 2px"
                                >
                                    地质三维与GPR3D集成
                                </div>
                                <div class="aeroiotflex_row" style="margin-bottom:2px">
                                    <div class="experienceItem_decorate2"></div>
                                    <div>智能分析</div>
                                </div>
                                <div class="experienceItem_tip5-tip" style="margin-bottom:16px;margin-left:10px;">
                                    自主开发的GPR3D超前预报建模软件，实现三维成像，精细分析
                                </div>
                                                                <div class="aeroiotflex_row" style="margin-bottom:2px">
                                    <div class="experienceItem_decorate2"></div>
                                    <div>探测范围</div>
                                </div>
                                <div class="experienceItem_tip5-tip" style="margin-bottom:16px;margin-left:10px;">
                                    弱信号提取技术可将探测范围扩展到前方50m、周边30m
                                </div>
                                                                <div class="aeroiotflex_row" style="margin-bottom:2px">
                                    <div class="experienceItem_decorate2"></div>
                                    <div>探测类型</div>
                                </div>
                                <div class="experienceItem_tip5-tip" style="margin-left:10px;">
                                    可以准确预报富水区，预防突泥涌水灾害发生
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/tunnel2.png"
                        alt=""
                    />
                </div>
            </div>
            <div
                class="aeroiotflex_row"
                style="margin-top: 36px; margin-bottom: 44px"
            >
                <div class="aeroiotflex_center">
                    <img
                        src="@/assets/experienceContentImg/tunnel3.png"
                        alt=""
                    />
                </div>
                <div class="aeroiotflex_col" style="margin-left: 76px">
                    <div
                        class="experienceItem_title"
                        style="margin-bottom: 22px"
                    >
                        进度安全态势一张图
                    </div>
                    <div class="aeroiotflex_row" style="margin-bottom: 15px">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelIcon7.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    BIM支持
                                </div>
                                <div class="experienceItem_tip5-tip" style="margin-bottom: 13px;">
                                    支持revit、FBX等bim模型的导入，隧道衬砌结构、车行道、钢筋网的精细建模与材质管理
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="aeroiotflex_row">
                        <div
                            class="experienceItem_tip5 aeroiotflex_row"
                            style="align-items: flex-start; margin-right: 42px"
                        >
                            <img
                                src="@/assets/experienceContentImg/tunnelIcon8.png"
                                alt=""
                                style="margin-right: 10px"
                            />
                            <div class="aeroiotflex_col">
                                <div
                                    class="experienceItem_tip5-title"
                                    style="margin-bottom: 8px; margin-top: 2px"
                                >
                                    CAD图形
                                </div>
                                <div class="experienceItem_tip5-tip">
                                    支持施工设计图与加深勘探图的加载，同时支持掌子面进度、物探结果的动态更新
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dialogActiveApp: {
            default: null,
            type: Object,
        },
    },
};
</script>

<style scoped>
.experienceItem_bottomborder {
    border-bottom: 1px dashed #e2e4e7;
}
.experienceItem_title {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 7px;
}
.experienceItem_tip1 {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    margin-bottom: 13px;
}
.experienceItem_tip2 {
    font-size: 14px;
    font-weight: 400;
    color: #0a0a0a;
    margin-bottom: 6px;
    width: 50%;
}
.experienceItem_tip6 {
    font-size: 14px;
    font-weight: 400;
    color: #0a0a0a;
    margin-bottom: 19px;
}
.experienceItem_tip3 {
    font-size: 14px;
    font-weight: 400;
    color: #0a0a0a;
    margin-bottom: 6px;
    margin-right: 50px;
}
.experienceItem_tip4 {
    width: 25%;
    font-size: 14px;
    font-weight: 400;
    color: #0a0a0a;
    margin-bottom: 13px;
}
.experienceItem_decorate1 {
    width: 26px;
    height: 4px;
    background: #2f8eff;
    margin-bottom: 17px;
}
.experienceItem_decorate2 {
    width: 4px;
    height: 4px;
    background: #2f8eff;
    border-radius: 50%;
    margin-right: 6px;
}
.experienceItem_tip5 {
    font-size: 14px;
    font-weight: 400;
    color: #0a0a0a;
}
.experienceItem_tip5-title {
    font-size: 14px;
    font-weight: 500;
    color: #303030;
}
.experienceItem_tip5-tip {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
}
.tunnelsanweitip {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #9a9a9a;
    padding-bottom: 40px;
    border-bottom: 1px dashed #e2e4e7;
}
.experienceItem_tip7 {
    font-size: 14px;
    font-weight: 400;
    color: #0a0a0a;
    margin-bottom: 14px;
    flex-wrap: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/experienceContent2.vue